import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import Modal from "react-bootstrap/Modal";
import { BackButton, DatatableCard, InputTextLarge, Loader } from '../../../components';
import { closeNotify, showPasswordModal, getMatriculeCodes, saveMatriculeCode, updateMatriculeCode } from '../actions';


const MatriculeCode = (props) => {

  const adminState = useSelector((state) => state.adminState);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMatriculeCodes());
    return () => dispatch(closeNotify())
  }, [dispatch]);

  const [id, setId] = useState('');
  const [code, setCode] = useState('');
  const [description, setDescription] = useState('');
  const [modalVisibility, setModalVisibility] = useState(false);

  const handleInputChange = e => {
    switch (e.target.id) {
      case 'code':
        setCode(e.target.value)
        break;
      case 'description':
        setDescription(e.target.value)
        break;

      default:
        break;
    }

  }

  const resetFields = () => {
    setId('');
    setCode('');
    setDescription('');
  }

  const handleSubmit = e => {

    e.preventDefault();

    let matriculeCode = { code, id, description }
  
    id === '' ? dispatch(saveMatriculeCode(matriculeCode)) : dispatch(updateMatriculeCode(matriculeCode))

    resetFields();
    setModalVisibility(false)

  }

  const addMatriculeCode = () => {
    resetFields()
    setModalVisibility(true)
  }

  const onEdit = (matriculeCode) => {

    setId(matriculeCode.id)
    setCode(matriculeCode.code)
    setDescription(matriculeCode.description)
    setModalVisibility(true)
  }

  const onDelete = (matriculeCode) => {
    dispatch(showPasswordModal(matriculeCode, 'matriculeCode'))
  }

  const columns = [
    {
      name: 'Nº',
      cell: (row, index, column, id) => <p>{index + 1}</p>
    },
    {
      name: 'Code',
      selector: 'code',
      sortable: true,
    },
    {
      name: 'Description',
      selector: 'description',
      sortable: true,
    },
    {
      name: "Date d'Ajout",
      selector: 'creationDate',
      sortable: true,
      cell: (row, index, column, selector) => <Moment format='DD/MM/YYYY'>{row.creationDate}</Moment>
    },
    {
      cell: (row, index, column, selector) => <button
        onClick={() => onEdit(row)}
        className="btn btn-sm btn-primary"><i className="fa fa-edit"></i></button>
    },
    {
      cell: (row, index, column, selector) => <button
        onClick={() => onDelete(row)}
        className="btn btn-sm btn-danger"><i className="fa fa-trash"></i></button>
    },
  ];

  const tableData = {
    columns,
    data: adminState.matriculeCodes
  };


  return (

    <div className="header pb-6">
      <div className="container-fluid">
        <div className="header-body">
          <div className="row align-items-center py-4">
            <div className="col-lg-12">
              <h6 className="h2 d-inline-block text-uppercase mb-0"><span className=""><i className="fa fa-list fa-lg mr-3"></i></span>LISTE DES CODES MATRICULE</h6>
              <h6 style={{ float: 'right' }} className="h2 d-inline-block text-uppercase mb-0"><button onClick={() => addMatriculeCode()} style={{ backgroundColor: '#19a0c2', color: '#fff' }} className="btn btn-sm"><i className="fa fa-plus fa-lg"></i> </button></h6>
              <BackButton />
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">

              <div className="card card-stats" >

                {adminState.loading ?

                  <Loader /> : <DatatableCard tableData={tableData} />}

              </div>
            </div>
          </div>
        </div>
        <Modal show={modalVisibility} centered onHide={() => setModalVisibility(false)}>
        <Modal.Header tabIndex='-1' aria-hidden closeButton>{id === '' ? 'Nouveau' : 'Edit'} code</Modal.Header>
        <Modal.Body>

          <form onSubmit={handleSubmit}>

          <div className="row">
          <InputTextLarge size={12} title="Code" style={{ textTransform: 'uppercase' }} name="code" id="code" onChange={handleInputChange} value={code} required />
          </div>

          <div className="row">
          <InputTextLarge size={12} title="Description" name="description" id="description" onChange={handleInputChange} value={description} required />
          </div>

            <div class="modal-footer pb-0 pt-0">
              <button
                type="button"
                class="btn"
                onClick={() => setModalVisibility(false)}>
                Close
              </button>
              <button type="submit" class="btn btn-primary">
                Save
              </button>
            </div>
          </form>

        </Modal.Body>

      </Modal>
      </div>
    </div>
  );
}

export default MatriculeCode